import styled from 'styled-components';

// PM analitik P7b — rapor merkezi yerleşimi. Sayfa tek kaydırmalıdır: üst şeritler sabit yükseklikte, yalnız DataTable satırları
// kayar (kapsayıcı height:100% + min-height:0; tablo yüksekliği ölçülür). Dar ekranda sayfa kayar, tablo kendi kaydırmasını bırakır.
export const PageWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    height: auto;
    overflow: visible;
  }
`;

export const Fixed = styled.div`
  flex-shrink: 0;
`;

export const TableArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    overflow: visible;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 12px;
`;

export const Field = styled.div`
  width: ${({ $w }) => $w || '220px'};
  max-width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  background: ${({ theme }) => theme.colors.bgColor};
  color: ${({ theme, $tone }) => ($tone === 'warning' ? theme.colors.auxiliar.warning
    : $tone === 'danger' ? theme.colors.auxiliar.danger
      : $tone === 'info' ? theme.colors.primary.main : theme.colors.text.primary)};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  white-space: nowrap;
`;

export const Kpis = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
`;

export const Kpi = styled.div`
  background: ${({ theme }) => theme.colors.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: 8px;
  padding: 10px 12px;
  min-width: 0;
`;

export const KpiLabel = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const KpiValue = styled.div`
  margin-top: 2px;
  font-size: ${({ theme }) => theme.metrics.font.size.lg};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const KpiSub = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const Notes = styled.ul`
  margin: 0 0 10px;
  padding-left: 18px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const StateBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 32px 16px;
  background: ${({ theme }) => theme.colors.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  text-align: center;
`;

export const Description = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 8px;
`;
